/*jslint browser:true, strict:false */

var empty_template = '<div class="grid-cell empty"></div>',
    firm_template = templater`<div class="grid-cell firm" data-firm="${'id'}">
      <img src="${'photo'}" alt="Photo of ${'name'}">
      <h6>${'attorney_name'}</h6>
      <svg class="icon close" viewBox="0 0 24 24">
        <use xlink:href="#close_clear"></use>
      </svg>
    </div>`,
    marker_html = templater`<div class="map-marker-container" data-firm="${'id'}">
      <img src="/attorney_finder/images/dist/icons/map_pin_hover.svg" class="hover">
      <img src="/attorney_finder/images/dist/icons/map_pin.svg" class="default">
    </div>`;

function templater(strings, ...keys) {
  return function(data) {
    let temp = strings.slice();
    keys.forEach((key, i) => {
      temp[i] = temp[i] + data[key];
    });
    return temp.join('');
  };
}

function convertToDom(html) {
  var d = document.createElement('div');
  d.innerHTML = html;
  return d.firstChild;
}
